import React from 'react';
import { Icon } from './Icon.js';
export const IconStack2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M2.25 3C1.00736 3 0 4.00736 0 5.25V9.25C0 10.4926 1.00736 11.5 2.25 11.5H9.75C10.9926 11.5 12 10.4926 12 9.25V5.25C12 4.00736 10.9926 3 9.75 3H2.25Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9.25 1.5C9.66421 1.5 10 1.16421 10 0.75C10 0.335786 9.66421 0 9.25 0H2.75C2.33579 0 2 0.335786 2 0.75C2 1.16421 2.33579 1.5 2.75 1.5H9.25Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconStack2Fill12.js.map